var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var CHARS = 'ABCDEFGHIJ';
/**
 * Replaces given char at given index in given string
 * @param {string} str String to replace char in
 * @param {number} index Index of char to replace
 * @param {string} chr New char
 * @returns {string} New string with replaced char
 */
function setCharAt(str, index, chr) {
    if (index > str.length - 1)
        return str;
    return str.substring(0, index) + chr + str.substring(index + 1);
}
var ArmaGridFormat = /** @class */ (function () {
    /**
     * @param {string} formatStr Grid format string
     */
    function ArmaGridFormat(formatStr) {
        var e_1, _a;
        this.formatStr = formatStr;
        var digitPositions = [];
        var matches = formatStr.matchAll(/[A-J]|[0-9]/g);
        try {
            for (var matches_1 = __values(matches), matches_1_1 = matches_1.next(); !matches_1_1.done; matches_1_1 = matches_1.next()) {
                var match = matches_1_1.value;
                var char = match[0];
                var index = CHARS.indexOf(char);
                var value = (index > -1) ? index : Number.parseInt(char, 10);
                digitPositions.push({
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    strIndex: match.index,
                    value: value,
                    isChar: index > -1
                });
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (matches_1_1 && !matches_1_1.done && (_a = matches_1.return)) _a.call(matches_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        this.digitPositions = digitPositions;
        this.max = Math.pow(10, digitPositions.length);
    }
    /**
     * Format number with given grid format
     * @param {number} num Number
     * @returns {string} formated number
     */
    ArmaGridFormat.prototype.formatGridNumber = function (num) {
        var mod = num % this.max;
        var numToFormat = num >= 0 ? mod : this.max + mod;
        // split the number into digits
        var digits = [];
        while (numToFormat > 0) {
            var digit = numToFormat % 10;
            digits.push(digit);
            numToFormat = (numToFormat - digit) / 10;
        }
        while (digits.length < this.digitPositions.length) {
            digits.push(0);
        }
        digits.reverse();
        var str = this.formatStr;
        for (var i = 0; i < this.digitPositions.length && i < digits.length; i++) {
            var _a = this.digitPositions[i], strIndex = _a.strIndex, value = _a.value, isChar = _a.isChar;
            var newValue = (value + digits[i]) % 10;
            var newChar = isChar ? CHARS.charAt(newValue) : newValue.toString();
            str = setCharAt(str, strIndex, newChar);
        }
        return str;
    };
    return ArmaGridFormat;
}());
export default ArmaGridFormat;
